import { tradeApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TRADES_ACTION_TYPE = createNamedActions('trades', {
  GET_TRADES_LIST: 'GET_TRADES_LIST',
  GET_TRADE: 'GET_TRADE',
  CREATE_TRADE: 'CREATE_TRADE',
  UPDATE_TRADE: 'UPDATE_TRADE',
  DELETE_TRADE: 'DELETE_TRADE',
  UPDATE_TRADE_STATUS: 'UPDATE_TRADE_STATUS',
  CLEAR_CURRENT_TRADE: 'CLEAR_CURRENT_TRADE',
});

export const getTradesListAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tradeApi.getTradesList(params);

  return dispatch({
    type: TRADES_ACTION_TYPE.GET_TRADES_LIST,
    payload: data,
  });
});

export const getTradeAction = catchAsyncActionError(({ id }) => async dispatch => {
  const { data } = await tradeApi.getTrade(id);

  return dispatch({
    type: TRADES_ACTION_TYPE.GET_TRADE,
    payload: data,
  });
});

export const createTradeAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await tradeApi.createTrade(body);

  return dispatch({
    type: TRADES_ACTION_TYPE.CREATE_TRADE,
    payload: data,
  });
});

export const updateTradeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tradeApi.updateTrade(params);

  return dispatch({
    type: TRADES_ACTION_TYPE.UPDATE_TRADE,
    payload: data,
  });
});

export const deleteTradeAction = catchAsyncActionError(({ id }) => async dispatch => {
  await tradeApi.deleteTrade(id);

  return dispatch({
    type: TRADES_ACTION_TYPE.DELETE_TRADE,
    meta: { id },
  });
});

export const updateTradeStatusAction = catchAsyncActionError(({ id, status }) => async dispatch => {
  const { data } = await tradeApi.updateTradeStatus(id, status);

  return dispatch({
    type: TRADES_ACTION_TYPE.UPDATE_TRADE_STATUS,
    payload: data,
  });
});

export const clearCurrentTradeAction = () => ({
  type: TRADES_ACTION_TYPE.CLEAR_CURRENT_TRADE,
});
